import React, { lazy } from 'react';
import { Facebook, Instagram, Twitter, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-[#fbf7dd] pt-16 pb-8" data-id="element-286">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-287">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-288">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-289">
            <div className="flex flex-col items-start" data-id="element-290">
              <img src="https://cdn.magicpatterns.com/uploads/8iyBWSo8vRExHMrz3iz275/Hold_My_Van_Full_Colour_Logo_1500px_V1.png" alt="Hold My Van" className="h-20 w-20 mb-4" loading="lazy" width="80" height="80" data-id="element-291" />
            </div>
            <p className="mt-6 text-gray-400 text-sm leading-relaxed" data-id="element-292">
              Secure, affordable, and convenient storage solutions for your
              caravan, motorhome, or boat in Perth, Western Australia.
            </p>
            <div className="flex gap-4 mt-6" data-id="element-293">
              <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-[#175445] transition-colors" data-id="element-294">
                <Facebook className="h-4 w-4" data-id="element-295" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-[#175445] transition-colors" data-id="element-296">
                <Instagram className="h-4 w-4" data-id="element-297" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-298">
            <h4 className="text-lg font-bold mb-6 text-[#FFC107]" data-id="element-299">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-300">
              <li data-id="element-301">
                <a href="/" className="hover:text-[#fbf7dd] transition-colors" data-id="element-302">
                  Home
                </a>
              </li>
              <li data-id="element-303">
                <a href="/blog" className="hover:text-[#fbf7dd] transition-colors" data-id="element-304">
                  Blog & Resources
                </a>
              </li>
              <li data-id="element-305">
                <a href="/#features" className="hover:text-[#fbf7dd] transition-colors" data-id="element-306">
                  Storage Facility
                </a>
              </li>
              <li data-id="element-307">
                <a href="/#pricing" className="hover:text-[#fbf7dd] transition-colors" data-id="element-308">
                  Pricing & Booking
                </a>
              </li>
              <li data-id="element-309">
                <a href="/#security" className="hover:text-[#fbf7dd] transition-colors" data-id="element-310">
                  Security
                </a>
              </li>
              <li data-id="element-311">
                <a href="/#contact" className="hover:text-[#fbf7dd] transition-colors" data-id="element-312">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-313">
            <h4 className="text-lg font-bold mb-6 text-[#FFC107]" data-id="element-314">Legal</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-315">
              <li data-id="element-316">
                <a href="#" className="hover:text-[#fbf7dd] transition-colors" data-id="element-317">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-318">
                <a href="#" className="hover:text-[#fbf7dd] transition-colors" data-id="element-319">
                  Terms & Conditions
                </a>
              </li>
              <li data-id="element-320">
                <a href="#" className="hover:text-[#fbf7dd] transition-colors" data-id="element-321">
                  Storage Agreement
                </a>
              </li>
              <li data-id="element-322">
                <a href="#" className="hover:text-[#fbf7dd] transition-colors" data-id="element-323">
                  Insurance Info
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Small */}
          <div data-id="element-324">
            <h4 className="text-lg font-bold mb-6 text-[#FFC107]" data-id="element-325">Contact</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-326">
              <li data-id="element-327">
                Perth Northern Corridor (Bullsbrook / Neerabup area – site
                location to be confirmed)
              </li>
              <li data-id="element-328">bookings@holdmyvan.com.au</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-329">
          <p data-id="element-330">
            &copy; {new Date().getFullYear()} HOLDMYVAN. All rights reserved.
          </p>
          <p className="mt-2 md:mt-0" data-id="element-331">Designed for Excellence</p>
        </div>
      </div>
    </footer>;
}